var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Doc as Doc } from "./doc";
import { ServerMessageType, } from "./live";
// Internal dependency mess between room and storage. Still need to figure out if room has a storage or if the Storage is going to use a room
export default class Storage {
    constructor(options) {
        this.options = options;
        this._doc = null;
        this._getInitialStatePromise = null;
        this._getInitialStateResolver = null;
    }
    createDocFromMessage(message) {
        if (message.items.length === 0) {
            this._doc = Doc.from(this.options.defaultRoot, this.options.getConnectionId(), this.options.dispatch);
        }
        else {
            this._doc = Doc.load(message.items, this.options.getConnectionId(), this.options.dispatch);
        }
    }
    getDocument() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._doc) {
                return this._doc;
            }
            if (this._getInitialStatePromise == null) {
                this.options.fetchStorage();
                this._getInitialStatePromise = new Promise((resolve) => (this._getInitialStateResolver = resolve));
            }
            yield this._getInitialStatePromise;
            return this._doc;
        });
    }
    onMessage(message) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            switch (message.type) {
                case ServerMessageType.InitialStorageState: {
                    this.createDocFromMessage(message);
                    (_a = this._getInitialStateResolver) === null || _a === void 0 ? void 0 : _a.call(this);
                    break;
                }
                case ServerMessageType.UpdateStorage: {
                    for (const op of message.ops) {
                        (_b = this._doc) === null || _b === void 0 ? void 0 : _b.apply(op);
                    }
                    break;
                }
            }
        });
    }
}
